import React from "react";

import StarterKit from "@tiptap/starter-kit";
import { DEFAULT_FIELDS, PlaceholderValue } from "./extensions/placeholder";

import { generateHTML } from "@tiptap/react";
import Underline from "@tiptap/extension-underline";
import DialogModal from "../dialogModal";

const EditorPreview = ({
  editor,
  record,
  onCancel,
  placeholderFields = DEFAULT_FIELDS,
  title,
}) => {
  return (
    <DialogModal
      open
      title={title}
      onCancel={onCancel}
      submitText={null}
      bodyRenderer={() => (
        <div
          className="tiptap"
          dangerouslySetInnerHTML={{
            __html: generateHtmlForRecord(editor, record, placeholderFields),
          }}
        />
      )}
    />
  );
};

export const generateHtmlForRecord = (editor, record, placeholderFields) => {
  if (!editor) return "";

  return (
    generateHTML(editor.getJSON(), [
      StarterKit,
      Underline,
      PlaceholderValue.configure({ record, fields: placeholderFields }),
    ])
      // Preserve empty paragraphs, so user has more control over layout
      .replace(/<p><\/p>/g, "<p><br /></p>")
  );
};

export default EditorPreview;
